<canvas #chart [id]="id"></canvas>
